export default __webpack_public_path__ + "d1fd70d39a3f7adf6314326f5cbc38db.jpg";